var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mouseenter":_vm.mouseOver,"mouseleave":_vm.mouseLeave}},[_c('h1',{staticClass:"svgfilter"},[_vm._t("default"),_c('div',{staticClass:"worktype"},[_vm._v("\n      "+_vm._s(_vm.worktype)+"\n    ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }